export class ApproveRejectService {
    
    Service: string;
    PaymentRequestID: number;
    
}
